const { viewportSize } = window.BAO.Utils
class TwoColumnMedia extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    if (this?.els?.title?.exists) {
      window.addEventListener('scroll', this.onScroll.bind(this), {
        passive: true,
      })
    }
  }

  onScroll () {
    const viewportOffset = this.getBoundingClientRect()

    const scrollAmountToHide =
      viewportSize() === 'xs' ? this.offsetHeight * -0.5 : -50

    this.els.title.element.classList.toggle(
      'sec-TwoColumnMedia_MainTitle-hidden',
      viewportOffset.top <= scrollAmountToHide,
    )
  }
}

customElements.define('two-column-media', TwoColumnMedia, {
  extends: 'section',
})
